import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import cn from '@/utils/cn';
import { fromCalendarDate, toCalendarDate } from './calendarDate';
import { spaInputClass } from './SPAInput';

// AIDEV-NOTE: react-datepicker on the SPA tokens — the popup is themed by `.spa-datepicker` in
// _sysadmin_spa.scss, so it reads right in both themes and on a light-pinned legacy mount. Values are
// calendar dates (YYYY-MM-DD) in the viewer's zone, the same contract as the report's URL params.
interface SPADatePickerProps {
  className?: string;
  id: string;
  maxDate?: string;
  minDate?: string;
  onChange: (value: string) => void;
  value: string;
}

export const DISPLAY_FORMAT = 'MMM d, yyyy';

const inputClass = spaInputClass;

const SPADatePicker = ({
  className, id, maxDate, minDate, onChange, value,
}: SPADatePickerProps) => (
  <ReactDatePicker
    calendarClassName="spa-datepicker"
    className={cn(inputClass, className)}
    dateFormat={DISPLAY_FORMAT}
    id={id}
    maxDate={maxDate ? fromCalendarDate(maxDate) : undefined}
    minDate={minDate ? fromCalendarDate(minDate) : undefined}
    popperClassName="spa-datepicker-popper"
    selected={value ? fromCalendarDate(value) : null}
    showPopperArrow={false}
    wrapperClassName="tw-block"
    onChange={(date: Date | null) => {
      if (date) onChange(toCalendarDate(date));
    }}
  />
);

export default SPADatePicker;
